import { Drawer } from "antd";
import "./CreateFolderModal.scss";
import { MenuFolderDto } from "../../generated/dashboard-client";
import { CreateFolderContent } from "./CreateFolderContent";
import { DownOutlined } from "@ant-design/icons";

export interface CreateFolderDrawerProps {
  ids: string[];
  isVisible: boolean;
  onClose: (ids: string[], folderToMove?: MenuFolderDto | null, folder?: MenuFolderDto) => void;
  folderToMove: MenuFolderDto | null,
  folderNameExists: (folder: MenuFolderDto | null, name: string) => boolean | undefined;
  activeFolder: MenuFolderDto | null
}

export function CreateFolderDrawer({
  ids,
  isVisible,
  onClose,
  folderToMove,
  folderNameExists,
  activeFolder
}: CreateFolderDrawerProps) {
  return (
    <Drawer
      className={"create-folder-modal mobile-bottom-menu"}
      visible={isVisible}
      onClose={() => onClose([])}
      closeIcon={<DownOutlined/>}
      placement={"bottom"}
      title={"New Folder"}
      height={"263px"}
    >
      <CreateFolderContent
        ids={ids}
        onClose={onClose}
        folderToMove={folderToMove}
        parentFolder={activeFolder}
        folderNameExists={folderNameExists}
      />
    </Drawer>
  );
}
